import React, { useState, useEffect } from 'react';

export default function NumberFilter({ value, operator, onChange, onApply }) {
  const [op, setOp] = useState(operator || 'igual');

  useEffect(() => { setOp(operator || 'igual'); }, [operator]);
  useEffect(() => {
    if (!value) setLocalVal({ desde: '', hasta: '' });
  }, [value]);
  const [localVal, setLocalVal] = useState(() => {
    if (op === 'entre' && value) {
      const parts = value.split(',');
      return { desde: parts[0] || '', hasta: parts[1] || '' };
    }
    return { desde: value || '', hasta: '' };
  });

  const handleOpChange = (e) => {
    const newOp = e.target.value;
    setOp(newOp);
    if (newOp === 'entre') {
      onChange(`${localVal.desde},${localVal.hasta}`, newOp);
    } else {
      onChange(localVal.desde, newOp);
    }
  };

  const handleValueChange = (val, field) => {
    const updated = { ...localVal, [field]: val };
    setLocalVal(updated);
    if (op === 'entre') {
      onChange(`${updated.desde},${updated.hasta}`, op);
    } else {
      onChange(val, op);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && onApply) onApply();
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <select className="cm-filter-select" value={op} onChange={handleOpChange}>
        <option value="igual">Igual</option>
        <option value="diferente">Diferente</option>
        <option value="mayor">Mayor</option>
        <option value="mayor_igual">Mayor e igual</option>
        <option value="menor">Menor</option>
        <option value="menor_igual">Menor e igual</option>
        <option value="entre">Entre</option>
      </select>
      {op === 'entre' ? (
        <div style={{ display: 'flex', gap: 2 }}>
          <input
            className="cm-filter-input"
            type="number"
            step="any"
            value={localVal.desde}
            onChange={(e) => handleValueChange(e.target.value, 'desde')}
            onKeyDown={handleKeyDown}
            placeholder="Desde..."
            style={{ width: '50%' }}
          />
          <input
            className="cm-filter-input"
            type="number"
            step="any"
            value={localVal.hasta}
            onChange={(e) => handleValueChange(e.target.value, 'hasta')}
            onKeyDown={handleKeyDown}
            placeholder="Hasta..."
            style={{ width: '50%' }}
          />
        </div>
      ) : (
        <input
          className="cm-filter-input"
          type="number"
          step="any"
          value={localVal.desde}
          onChange={(e) => handleValueChange(e.target.value, 'desde')}
          onKeyDown={handleKeyDown}
          placeholder="Valor..."
        />
      )}
    </div>
  );
}
